// Character color configuration with pastel theme
export const CHARACTER_COLORS = {
  iroha: {
    name: 'いろは',
    primary: 'bg-pink-400',
    hover: 'hover:bg-pink-500',
    secondary: 'bg-pink-200',
    secondaryHover: 'hover:bg-pink-300',
    text: 'text-white',
    border: 'border-pink-300',
    background: 'bg-pink-50'
  },
  yachiyo: {
    name: 'やちよ',
    primary: 'bg-blue-400',
    hover: 'hover:bg-blue-500',
    secondary: 'bg-blue-200',
    secondaryHover: 'hover:bg-blue-300',
    text: 'text-white',
    border: 'border-blue-300',
    background: 'bg-blue-50'
  },
  sana: {
    name: 'さな',
    primary: 'bg-green-400',
    hover: 'hover:bg-green-500',
    secondary: 'bg-green-200',
    secondaryHover: 'hover:bg-green-300',
    text: 'text-white',
    border: 'border-green-300',
    background: 'bg-green-50'
  },
  tsuruno: {
    name: '鶴乃',
    primary: 'bg-orange-400',
    hover: 'hover:bg-orange-500',
    secondary: 'bg-orange-200',
    secondaryHover: 'hover:bg-orange-300',
    text: 'text-white',
    border: 'border-orange-300',
    background: 'bg-orange-50'
  },
  felicia: {
    name: 'フェリシア',
    primary: 'bg-purple-400',
    hover: 'hover:bg-purple-500',
    secondary: 'bg-purple-200',
    secondaryHover: 'hover:bg-purple-300',
    text: 'text-white',
    border: 'border-purple-300',
    background: 'bg-purple-50'
  },
  kuroe: {
    name: '黒江',
    primary: 'bg-gray-500',
    hover: 'hover:bg-gray-600',
    secondary: 'bg-gray-300',
    secondaryHover: 'hover:bg-gray-400',
    text: 'text-white',
    border: 'border-gray-400',
    background: 'bg-gray-100'
  }
};

// Helper function to get character colors
export const getCharacterColors = (charId) => {
  return CHARACTER_COLORS[charId] || CHARACTER_COLORS.iroha;
};